var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStandardDeviation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.429 14c.315 0 .571.256.571.571V25.43a.571.571 0 0 1-.571.571H.57A.571.571 0 0 1 0 25.429V14.57C0 14.256.256 14 .571 14zm14 0c.315 0 .571.256.571.571V25.43a.571.571 0 0 1-.571.571H14.57a.571.571 0 0 1-.571-.571V14.57c0-.315.256-.571.571-.571zm-14-14c.315 0 .571.256.571.571V11.43a.571.571 0 0 1-.571.571H.57A.571.571 0 0 1 0 11.429V.57C0 .256.256 0 .571 0zM20 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStandardDeviation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/standard-deviation.f94646d40cd893863e9b1064da7a7313.svg";